import React from "react";
import { Button, ButtonGroup, Col, Row, Stack, ToggleButton } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faFolderPlus,
  faGripHorizontal,
  faList,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import { LoadingSpinner } from "../../common/Loading/LoadingSpinner";

interface DocumentToolbarProps {
  selectedView: string;
  setSelectedView: (view: string) => void;
  onAddFolder: () => void;
  onUpFolder: () => void;
  onRefresh: () => void;
  hasParentFolder: boolean;
  currentPath: string;
  defaultFolder: string;
  isLoading: boolean;
}

export const DocumentToolbar: React.FC<DocumentToolbarProps> = ({
  selectedView,
  setSelectedView,
  onAddFolder,
  onUpFolder,
  onRefresh,
  hasParentFolder,
  currentPath,
  defaultFolder,
  isLoading,
}) => (
  <Row>
    <Col xs="auto">
      <Stack direction="horizontal" gap={2}>
        <ButtonGroup>
          <ToggleButton
            id="radio-tile"
            type="radio"
            variant="outline-success"
            name="view"
            value="tile"
            checked={selectedView === "tile"}
            onChange={() => setSelectedView("tile")}
            title="Tile view"
          >
            <FontAwesomeIcon icon={faGripHorizontal} />
          </ToggleButton>
          <ToggleButton
            id="radio-list"
            type="radio"
            variant="outline-success"
            name="view"
            value="list"
            checked={selectedView === "list"}
            onChange={() => setSelectedView("list")}
            title="List view"
          >
            <FontAwesomeIcon icon={faList} />
          </ToggleButton>
        </ButtonGroup>
        <Button variant="secondary" onClick={onAddFolder}>
          <FontAwesomeIcon className="me-2" icon={faFolderPlus} />
          New Folder
        </Button>
        <Button
          variant="secondary"
          disabled={!hasParentFolder || currentPath === defaultFolder}
          onClick={onUpFolder}
        >
          <FontAwesomeIcon className="me-2" icon={faArrowUp} />
          Up Folder
        </Button>
        <Button variant="secondary" onClick={onRefresh}>
          {isLoading ? <LoadingSpinner /> : <FontAwesomeIcon icon={faRefresh} />}
        </Button>
        <span className="ps-2">Current folder:</span>
      </Stack>
    </Col>
  </Row>
);
